// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rk-modal .content-wrapper {
	margin: 0 auto;
	z-index: 5002;
	position: relative;
	height: 100%;
	width: auto;
	padding: 20px 40px;
	box-sizing: border-box;
	max-width: 1024px;
}

.rk-modal .content {
	background-color: #fff;
	border-radius: 5px;
	height: 100%;
}

.rk-modal .external-app-frame {
	height: 100% !important;
}

@media (max-width: 768px) {
	.rk-modal .content-wrapper {
		padding: 0;
	}

	.rk-modal .content {
		border-radius: 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/ExternalApplicationModal.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".rk-modal .content-wrapper {\n\tmargin: 0 auto;\n\tz-index: 5002;\n\tposition: relative;\n\theight: 100%;\n\twidth: auto;\n\tpadding: 20px 40px;\n\tbox-sizing: border-box;\n\tmax-width: 1024px;\n}\n\n.rk-modal .content {\n\tbackground-color: #fff;\n\tborder-radius: 5px;\n\theight: 100%;\n}\n\n.rk-modal .external-app-frame {\n\theight: 100% !important;\n}\n\n@media (max-width: 768px) {\n\t.rk-modal .content-wrapper {\n\t\tpadding: 0;\n\t}\n\n\t.rk-modal .content {\n\t\tborder-radius: 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
